import { Observable } from 'rxjs'
import { LoaderControl } from '@adex/shared/models/loaders/loader-control'
import { ILoaderControl } from '@adex/shared/models/loaders/models/loader-control'
import { AbstractBaseLoader } from '@adex/shared/models/loaders/base-loader'


export class BaseLoaderContainer<T> {
  public readonly model$: Observable<T>
  public readonly loadingModel$: Observable<boolean>
  private readonly control: ILoaderControl<T>

  constructor(customControlFactory: () => ILoaderControl<T>)
  constructor(modelLoader: AbstractBaseLoader, modelName?: string)
  constructor(factory: AbstractBaseLoader | (() => ILoaderControl<T>), modelName?: string) {
    this.control = factory instanceof AbstractBaseLoader ? new LoaderControl<T>(factory, modelName) : factory()
    this.model$ = this.control.data$
    this.loadingModel$ = this.control.dataLoaded$
  }

  protected update(modelName: string): void {
    this.control.load(modelName)
  }
}
